import { MapPin } from "lucide-react";
import { CommandGroup, CommandItem } from "@/components/ui/command";
import {
  LOC_KIND_PLURAL,
  LOC_KINDS,
  locationLabel,
  type LocSuggestion,
} from "@/lib/search-locations";

const fmt = new Intl.NumberFormat("es-ES");

/**
 * Sugerencias de ubicación agrupadas por nivel: "Alicante (Alacant)" cuando
 * se encontró por un alias, el padre entre paréntesis y, si se pide, el
 * número de anuncios.
 */
export function LocationOptions({
  items,
  onSelect,
  showCount = false,
}: {
  items: LocSuggestion[];
  onSelect: (loc: LocSuggestion) => void;
  showCount?: boolean;
}) {
  if (items.length === 0) {
    return (
      <div className="px-4 py-6 text-center text-sm text-muted-foreground">
        No se encontraron ubicaciones.
      </div>
    );
  }
  return (
    <>
      {LOC_KINDS.map((kind) => {
        const group = items.filter((l) => l.kind === kind);
        if (!group.length) return null;
        return (
          <CommandGroup key={kind} heading={LOC_KIND_PLURAL[kind]}>
            {group.map((l) => (
              <CommandItem
                key={`${kind}-${l.id}`}
                value={`${kind}-${l.id}`}
                onSelect={() => onSelect(l)}
              >
                <MapPin className="mr-2 h-4 w-4 shrink-0 text-muted-foreground" />
                <span className="min-w-0 truncate">
                  {locationLabel(l)}
                  {l.parent && (
                    <span className="ml-1 text-xs text-muted-foreground">({l.parent})</span>
                  )}
                </span>
                {showCount && l.count != null && (
                  <span className="ml-auto pl-2 text-xs tabular-nums text-muted-foreground">
                    {fmt.format(l.count)}
                  </span>
                )}
              </CommandItem>
            ))}
          </CommandGroup>
        );
      })}
    </>
  );
}
